import { EditorContainer } from '@modules/editor';
import { InputBaseComponentProps, styled } from '@mui/material';
import { Editor, EditorContent } from '@tiptap/react';
import { forwardRef } from 'react';

const EditorStyled = styled(EditorContainer)(() => ({
  maxHeight: '10em',
  overflowY: 'auto',
  height: 'unset !important',
  margin: '0 !important',
  p: {
    margin: 0,
  },

  '& .ProseMirror': {
    wordBreak: 'break-word',
    padding: '0 !important',
    '&:focus': {
      boxShadow: 'none !important',
    },
  },
}));

type Props = InputBaseComponentProps & {
  editor: Editor;
};

export const ConversationMessageEditor = forwardRef(
  ({ editor, ...props }: Props, ref) => (
    <EditorStyled editor={editor} ref={ref} {...(props as any)}>
      <EditorContent editor={editor} />
    </EditorStyled>
  ),
);
